import React, { useState } from 'react';

const useErrorModal = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [content, setContent] = useState<string>('');

  const setErrorContent = (_content: string) => {
    setIsOpen(true);
    setContent(_content);
  };
  const toggleModal = () => setIsOpen((curr) => !curr);

  return { isOpen, content, setErrorContent, toggleModal };
};

export default useErrorModal;
